import axios from '@/config/httpConfig'
// 获取默认视图
export function SetViewDefault(data) {
    return axios.post('/view/list/setViewDefault', data)
}
